import type { ComponentChildren } from 'preact';
import { cn, type UiBaseProps } from './types';

interface PageProps extends UiBaseProps {
  children: ComponentChildren;
}

/** Page content wrapper — max-width, padding, vertical rhythm. */
export function Page({ children, className }: PageProps) {
  return <main className={cn('ui-page', className)}>{children}</main>;
}
